import * as XLSX from "xlsx";
import { computeDerivedStatus, daysRemainingLabel } from "@/lib/status";
import { format } from "date-fns";

const buildRows = (tasks) =>
  tasks.map((t) => ({
    Title: t.title,
    Category: t.category,
    "Due Date": t.dueDate,
    Status: t.status,
    "Derived Status": computeDerivedStatus(t),
    "Days Remaining": daysRemainingLabel({
      ...t,
      derivedStatus: computeDerivedStatus(t),
    }),
    "Has Document": t.document ? "Yes" : "No",
    "Created At": t.createdAt || "",
    "Updated At": t.updatedAt || "",
  }));

const filename = (ext) => `ndm-compliance-${format(new Date(), "yyyyMMdd-HHmm")}.${ext}`;

const downloadBlob = (data, name, type) => {
  const blob = new Blob([data], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export function exportToCSV(tasks) {
  const rows = buildRows(tasks);
  if (rows.length === 0) return;
  const headers = Object.keys(rows[0]);
  const escape = (v) => {
    const s = v == null ? "" : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = [
    headers.join(","),
    ...rows.map((r) => headers.map((h) => escape(r[h])).join(",")),
  ].join("\n");
  downloadBlob("\uFEFF" + csv, filename("csv"), "text/csv;charset=utf-8;");
}

export function exportToXLSX(tasks) {
  const rows = buildRows(tasks);
  if (rows.length === 0) return;
  const ws = XLSX.utils.json_to_sheet(rows);
  const colWidths = Object.keys(rows[0]).map((k) => ({
    wch: Math.max(k.length, ...rows.map((r) => String(r[k] ?? "").length)) + 2,
  }));
  ws["!cols"] = colWidths;
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Compliance");
  const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  downloadBlob(
    buf,
    filename("xlsx"),
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  );
}
